<template>
  <div class="enterprise">
    <lr-link
      class="enterprise-banner"
      target="_blank"
      :to="banner.url"
      @click="handleClickBanner()"
    >
      <img src="../../assets/image/enterprise/banner.png" />
      <div class="enterprise-banner-text">
        <p v-text="banner.title"></p>
        <span v-text="banner.tips"></span>
      </div>
    </lr-link>
    <training-system :training="trainingList"></training-system>
    <personal-service
      :personalService="personalServiceList"
      :serviceProcess="serviceProcessList"
    ></personal-service>
    <team :team="teamList"></team>
    <video-learning :product="productList"></video-learning>
  </div>
</template>
<script>
import PersonalService from './components/personal-service';
import TrainingSystem from './components/training-system';
import Team from './components/team';
import VideoLearning from './components/video-learning';
import { FOOTER_HEIGHT } from '@/common/constant';
import { debounce } from '@/common/utils';
export default {
  components: {
    TrainingSystem,
    PersonalService,
    Team,
    VideoLearning,
  },

  data() {
    return {
      banner: {
        title: '桌面生产力系列课程',
        tips: '一站式助力政企人才培养',
        url: 'https://www.wps.cn/learning/article/simple/id/330387.html',
      },
      serviceProcessList: [
        {
          text: '需求填写',
          icon: 'iconicon_demand',
        },
        {
          text: '电话回访',
          icon: 'iconicon_phone',
        },
        {
          text: '确认需求',
          icon: 'iconicon_confirm',
        },
        {
          text: '定制方案',
          icon: 'iconicon_plan',
        },
        {
          text: '实施服务',
          icon: 'iconicon_service',
        },
        {
          text: '服务交付',
          icon: 'iconicon_delivery',
        },
      ],
      personalServiceList: [
        {
          title: '培训课程定制',
          tips: '量身定制人才培养方案',
          img: 'training',
          url: 'https://f.wps.cn/w/OHjz9gY2/?chan=pc_company_made',
          dw: 'traincustom',
          btnColor: 'green',
        },
        {
          title: '视频课程定制',
          tips: '情景化视频定制',
          img: 'video',
          url: 'https://f.wps.cn/w/zIxwaAe4/?chan=pc_company_made',
          dw: 'videocustom',
          btnColor: 'purple',
        },
        {
          title: '模板设计与美化',
          tips: '精美专业模板设计',
          img: 'template',
          url: 'https://f.wps.cn/w/heZ7kz5p/?chan=pc_company_made',
          dw: 'pptcustom',
          btnColor: 'red',
        },
      ],
      teamList: [
        {
          name: '万涛',
          content:
            '长期深耕政企办公领域，软件应用实战经验丰富，曾为各级党政机关单位和百余家知名企业提供知识服务。严谨专业、幽默风趣、广受好评。',
          course: '一份高大上的汇报该怎么做？',
          courseUrl:
            'https://www.wps.cn/learning/article/simple/id/330357.html',
          img: 'wantao',
          courseId: '330357',
        },
        {
          name: '罗丽虹',
          content:
            '深入了解WPS全线产品特性，把握技巧应用规律，办公教学实战经验丰富。讲课认真负责，活泼生动，深受学员喜爱。',
          course: '职场办公全能力速成课',
          courseUrl:
            'https://www.wps.cn/learning/article/simple/id/330354.html',
          img: 'luolihong',
          courseId: '330354',
        },
        {
          name: '袁远尧',
          content:
            '10余年专职Office讲师经历，曾为众多企事业单位提供各类培训解决方案，授课风格轻松、生动、贴近工作，并帮助学员将培训成果在政企落地生效。',
          course: '快速提升数据处理与分析能力',
          courseUrl:
            'https://www.wps.cn/learning/article/simple/id/330356.html',
          img: 'yuanyuanxiao',
          courseId: '330356',
        },
        {
          name: '伍昊',
          content:
            '专注数据化培训十年，国内首先提出"天下第一表"和"三表概念" ，将表格教学提升至企业数据化管理层面的开拓者。',
          course: '基于WPS实操的数据管理能力...',
          courseUrl:
            'https://www.wps.cn/learning/article/simple/id/330365.html',
          img: 'wuhao',
          courseId: '330365',
        },
      ],
      trainingList: [
        {
          title: '生产力系列',
          tips: '一站式全能办公',
          img: 'productivity',
          url: 'https://www.wps.cn/learning/article/simple/id/330387.html',
          id: '330387',
        },
        {
          title: '聚焦行业办公专题',
          tips: '各大行业培训课程大集合',
          img: 'focus',
          url: 'https://www.wps.cn/learning/article/simple/id/330388.html',
          id: '330388',
        },
        {
          title: '办公业务流深度定制',
          tips: '各类项目培训课程大集合',
          img: 'office',
          url: 'https://www.wps.cn/learning/article/simple/id/330389.html',
          id: '330389',
        },
      ],
      productList: [
        {
          title: 'WPS 2016介绍',
          content:
            '该课程讲解WPS2016在工作中的应用，课程分为WPS文字、WPS表格、WPS演示三大组件。',
          url: 'https://www.wps.cn/learning/enterprise/detail/id/13575.html',
          id: '13575',
        },
        {
          title: 'WPS 2019介绍',
          content:
            '本课程介绍新版本WPSOffice2019中改进及新增的功能，提供更个性化且更高效率的职场办公体验。',
          url: 'https://www.wps.cn/learning/enterprise/detail/id/13590.html',
          id: '13590',
        },
        {
          title: '软件正版化',
          content:
            '此课程介绍正版软件的软件基础常识、盗版软件识别，解答正版化工作中所遇到的问题。',
          url: 'https://www.wps.cn/learning/enterprise/detail/id/13576.html',
          id: '13576',
        },
      ],
    };
  },
  methods: {
    handleClickBanner() {
      this.$collect.enterpriseHomepageClick({ click: 'banner' });
    },

    //滚动触底事件
    isScrollBottom() {
      const { bottom } = document.body.getBoundingClientRect();
      const { innerHeight } = window;

      if (bottom - innerHeight <= FOOTER_HEIGHT) {
        this._isScrollBottom = true;
      }
    },

    init() {
      // 上报详情页展示
      this.$collect.enterpriseHomepageShow();

      // 监听滚动到底部的事件
      this.debounceisScrollBottom = debounce(this.isScrollBottom, 300);
      window.addEventListener('scroll', this.isScrollBottom);

      // 上报页面结束
      window.addEventListener('beforeunload', () => {
        if (this._isBeforeUnload) return;
        this._isBeforeUnload = true;
        this.$collect.enterpriseHomepageEndShow({
          view: this._isScrollBottom ? 'yes' : 'no',
        });
      });
    },
  },
  mounted() {
    this.init();
  },

  destroyed() {
    window.removeEventListener('scroll', this.debounceisScrollBottom);
  },
};
</script>
<style lang="scss" scoped>
.enterprise {
  &-banner {
    width: 100%;
    height: 288px;
    display: block;
    overflow: hidden;
    position: relative;

    > img {
      width: 100%;
      height: 100%;
      cursor: pointer;
      &:hover {
        cursor: pointer;
        transition: all 1s;
        transform: scale(1.1);
      }
    }

    &-text {
      position: absolute;
      top: 50%;
      left: 140px;
      transform: translate(0, -50%);
      text-align: center;
      color: black;
      cursor: pointer;
      user-select: none;
      color: #ffffff;
      pointer-events: none;
      > p {
        font-size: 50px;
        font-weight: 600;
        margin-bottom: 8px;
        color: #ffffff;
        text-shadow: 0px 2px 6px rgba(0, 0, 0, 0.16);
      }
      > span {
        font-size: 22px;
        font-weight: 500;
      }
    }
  }
}
</style>
<style lang="scss">
.enterprise-title {
  color: black;
  font-size: 24px;
  font-weight: bold;
  padding: 60px 0 30px;
  display: flex;
  justify-content: space-between;
  user-select: none;

  > a {
    font-size: 14px;
    font-weight: 400;
    color: #222226;
    &:hover {
      color: #417ff9;
    }
  }
}
.anchor {
  display: block;
  position: relative;
  top: -42px;
  visibility: hidden;
}
</style>
